module.exports = __webpack_public_path__ + "static/media/3.612717ec.jpg";